import { render } from "./mediaLib.vue?vue&type=template&id=1262feb5&scoped=true"
import script from "./mediaLib.vue?vue&type=script&lang=js"
export * from "./mediaLib.vue?vue&type=script&lang=js"

import "./mediaLib.vue?vue&type=style&index=0&id=1262feb5&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1263437306/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1262feb5"]])

export default __exports__